import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Icon from '../../components/AppIcon';

const GoogleOAuthCallback = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const payload = { type: 'google-oauth-complete' };

    if (window.opener) {
      try {
        window.opener.postMessage(payload, window.location.origin);
        window.close();
        return;
      } catch {
        // COOP may block opener access; fall through to redirect
      }
    }

    const timer = setTimeout(() => {
      navigate('/ai-assistant/setup', { replace: true });
    }, 1500);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="bg-card border border-border rounded-xl p-8 max-w-md w-full text-center shadow-elevation-md">
        <div className="w-14 h-14 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="CheckCircle2" size={28} className="text-success" />
        </div>
        <h1 className="text-xl font-semibold text-foreground mb-2">{t('auth.googleConnected')}</h1>
        <p className="text-sm text-muted-foreground">
          {t('auth.oauthReturnToSettings')}
        </p>
      </div>
    </div>
  );
};

export default GoogleOAuthCallback;
